
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./components/AuthProvider";
import { SubscriptionGuard } from "./components/subscription/SubscriptionGuard";
import { AdminGuard } from "./components/cms/AdminGuard";
import { CMSGuard } from "./components/cms/CMSGuard";
import Landing from "./pages/Landing";
import DashboardPage from "./pages/DashboardPage";
import Projects from "./pages/Projects";
import ProfileSettings from "./pages/ProfileSettings";
import LearnMore from "./pages/LearnMore";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Resources from "./pages/Resources";
import PrivacyTerms from "./pages/PrivacyTerms";
import NotFound from "./pages/NotFound";
import Auth from "./pages/Auth";
import Invoices from "./pages/Invoices";
import AnalyticsPage from "./pages/AnalyticsPage";
import { Toaster } from "@/components/ui/toaster"
import BlogCMS from "./pages/BlogCMS";
import Contact from "./pages/Contact";
import AdminDashboard from "./pages/AdminDashboard";
import InvitePage from "./pages/InvitePage";
import ProjectDetail from "./pages/ProjectDetail";
import TeamDashboard from "./pages/TeamDashboard";
import TeamProjectDetail from "./pages/TeamProjectDetail";
import TeamInvitePage from "./pages/TeamInvitePage";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 3,
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <AuthProvider>
            <div className="App">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/dashboard" element={
                  <SubscriptionGuard>
                    <DashboardPage />
                  </SubscriptionGuard>
                } />
                <Route path="/projects" element={
                  <SubscriptionGuard>
                    <Projects />
                  </SubscriptionGuard>
                } />
                  <Route path="/projects/:id" element={
                    <SubscriptionGuard>
                      <ProjectDetail />
                    </SubscriptionGuard>
                  } />
                   <Route path="/team-projects" element={
                     <SubscriptionGuard>
                       <TeamDashboard />
                     </SubscriptionGuard>
                   } />
                   <Route path="/team-projects/:id" element={
                     <SubscriptionGuard>
                       <TeamProjectDetail />
                     </SubscriptionGuard>
                   } />
                   <Route path="/invite/:token" element={<InvitePage />} />
                   <Route path="/team-invite/:token" element={<TeamInvitePage />} />
                  <Route path="/analytics" element={
                    <SubscriptionGuard>
                      <AnalyticsPage />
                    </SubscriptionGuard>
                  } />
                  <Route path="/invoices" element={
                    <SubscriptionGuard>
                      <Invoices />
                    </SubscriptionGuard>
                  } />
                  <Route path="/profile" element={
                    <SubscriptionGuard>
                      <ProfileSettings />
                    </SubscriptionGuard>
                  } />
                  <Route path="/auth" element={<Auth />} />
                  
                  <Route path="/learn-more" element={<LearnMore />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/resources" element={<Resources />} />
                  <Route path="/privacy-terms" element={<PrivacyTerms />} />
                  
                  <Route path="/contact" element={<Contact />} />
                  
                  <Route path="/admin/dashboard" element={
                    <AdminGuard>
                      <AdminDashboard />
                    </AdminGuard>
                  } />
                  
                  <Route path="/blog-cms" element={
                    <CMSGuard>
                      <BlogCMS />
                    </CMSGuard>
                  } />
                  
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <Toaster />
                <SpeedInsights />
                <Analytics />
              </div>
          </AuthProvider>
        </Router>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
